import React, { Component } from "react";
export class ShowHide extends Component {
    render() {
        const { show, hide, children } = this.props;
        let shouldShow = true;
        if (typeof hide === "boolean") {
            shouldShow = !hide;
        }
        if (typeof show === "boolean") {
            shouldShow = show; // preference to show property
        }
        return (
            <>
                {shouldShow ? children : null}
            </>
        );
    }
}
